<template>
  <DynamicModal
    :showModal="showAddModal"
    :persistent="false"
    @clickOutside="closeModal"
    title="Add Team"
    maxWidth="800px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn
          icon
          depressed
          color="primary"
          @click="closeModal"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <v-form ref="addTeamForm">
        <v-row class="mt-2">
          <v-col cols="12">
            <SimplePageHeader title="Team"></SimplePageHeader>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <UsersDropDownList
              :userId="managerId"
              :isRequired="true"
              label="Team Leader"
              :securityRoles="[MANAGER]"
              :onlyActiveUsers="true"
              @userIdChange="handleManagerIdChange"
              @userNameChange="handleManagerNameChange"
            ></UsersDropDownList>
          </v-col>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="teamName"
              label="Team Name"
              validate-on-blur
              :rules="[required('Name')]"
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-2 mb-2">
          <v-col cols="12">
            <SimplePageHeader title="Commission Override"></SimplePageHeader>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" v-if="false">
            <FormattedNumberField
              label="Base Amount"
              :value="commissionBaseAmount"
              prepend-inner-icon="attach_money"
              @valueChange="(newValue) => this.commissionBaseAmount = newValue"
            ></FormattedNumberField>
          </v-col>
          <v-col cols="12" sm="6">
            <FormattedNumberField
              label="Commission"
              :value="commissionPercentage"
              append-icon="percent"
              :validate-on-blur="true"
              :rules="[isValidCommission]"
              @valueChange="(newValue) => this.commissionPercentage = newValue"
            ></FormattedNumberField>
          </v-col>
        </v-row>
        <v-row class="mt-2 mb-2">
          <v-col cols="12">
            <SimplePageHeader title="Team Members"></SimplePageHeader>
          </v-col>
        </v-row>
        <TeamMembersCollector
          :teamMembers="teamMembersTempArray"
          @addTeamMember="addTeamMemberHandler"
          @removeMember="removeMemberHandler"
          @memberIdChange="memberIdChangeHandler"
          @roleChange="roleChangeHandler"
        ></TeamMembersCollector>
      </v-form>
    </v-container>
    <v-container fluid slot="buttons" class="pb-0 mb-0">
      <div class="row d-flex justify-end">
        <div class="col-6">
          <v-btn
            block
            depressed
            color="primary"
            @click="saveTeamHandler"
          >
            Add
          </v-btn>
        </div>
        <div class="col-6">
          <v-btn
            block
            depressed
            outlined
            @click="closeModal"
          >
            Cancel
          </v-btn>
        </div>
      </div>
    </v-container>
  </DynamicModal>
</template>

<script>
import DynamicModal from '@/components/dialogs/DynamicModal'
import { SimplePageHeader } from '@/components/pageComponents'
import { required } from '@/lib/formValidations'
import TeamMembersCollector from '@/components/teams/TeamMembersCollector'
import { mapActions } from 'vuex'
import UsersDropDownList from '@/components/users/UsersDropDownList'
import { MANAGER } from '@/lib/constants/securityRoles'
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    UsersDropDownList,
    TeamMembersCollector,
    DynamicModal,
    SimplePageHeader,
    FormattedNumberField
  },
  data () {
    return {
      showAddModal: false,
      teamName: null,
      managerId: null,
      commissionBaseAmount: null,
      commissionPercentage: null,
      teamMembersTempArray: [],
      MANAGER
    }
  },
  methods: {
    ...mapActions('teams', ['saveTeam']),
    required,
    showModal () {
      this.showAddModal = true
    },
    closeModal () {
      this.clearTeam()
      this.showAddModal = false
    },
    handleManagerIdChange (newValue) {
      this.managerId = newValue
    },
    handleManagerNameChange (firstName, lastName) {
      this.teamName = firstName + ' ' + lastName + '\'s Team'
    },
    clearTeam () {
      this.teamName = null
      this.managerId = null
      this.commissionBaseAmount = null
      this.commissionPercentage = null
      this.teamMembersTempArray = []
      this.$refs.addTeamForm.resetValidation()
    },
    async saveTeamHandler () {
      if (this.$refs.addTeamForm.validate()) {
        await this.saveTeam({
          teamName: this.teamName,
          managerId: this.managerId,
          commissionBaseAmount: this.commissionBaseAmount,
          commissionPercentage: this.commissionPercentage,
          teamMembers: this.teamMembersTempArray
        })
        this.clearTeam()
        this.showAddModal = false
        this.$emit('saveTeam')
      }
    },
    addTeamMemberHandler () {
      this.teamMembersTempArray.push({ memberId: null, role: null })
    },
    memberIdChangeHandler ({ id, memberId }) {
      this.teamMembersTempArray[id]['memberId'] = memberId
    },
    roleChangeHandler ({ id, role }) {
      this.teamMembersTempArray[id]['role'] = role
    },
    removeMemberHandler (id) {
      this.teamMembersTempArray.splice(id, 1)
    },
    isValidCommission () {
      if (this.commissionPercentage > 100 || this.commissionPercentage < 0) {
        return 'Commission Percent must be between 0 and 100'
      } else {
        return true
      }
    }
  }
}
</script>
